import { notesTypes } from '../constants';

export const getLocality = (pinCode) => ({
  type: notesTypes.FETCH_LOCALITY,
  endpoint: `v1/common/postcode/?postcode=${pinCode}`,
  method: 'get'
});

export const getUserStatus = () => ({
  type: notesTypes.GET_USER_STATUS,
  endpoint: 'v1/user/me/physical_notes_status/',
  method: 'get'
});

export const createOrder = (payload) => ({
  type: notesTypes.CREATE_NOTES_ORDER,
  endpoint: 'v1/user/me/physical_notes/',
  method: 'post',
  data: payload
});
